import React, { useCallback, useRef, useState } from 'react';
import CreditConfirmDialog from './CreditConfirmDialog';

/**
 * Reusable AI-credit gate. Wraps any AI action behind the CreditConfirmDialog.
 *
 *   const { requestRun, dialog } = useCreditGate('vision_analysis', 'Confirm Vision Analysis');
 *   <Button onClick={() => requestRun(runFullPipeline)}>Run</Button>
 *   {dialog}
 *
 * requestRun(fn) stores fn and opens the dialog; on Confirm (after credits are
 * metered/consumed) fn() is executed. The REASON master tenant sees "Unlimited".
 */
export function useCreditGate(actionKey, title) {
  const [open, setOpen] = useState(false);
  const pendingRef = useRef(null);

  const requestRun = useCallback((fn) => {
    pendingRef.current = typeof fn === 'function' ? fn : null;
    setOpen(true);
  }, []);

  const dialog = (
    <CreditConfirmDialog
      open={open}
      onOpenChange={setOpen}
      actionKey={actionKey}
      title={title}
      onConfirm={() => { const f = pendingRef.current; pendingRef.current = null; if (f) f(); }}
    />
  );

  return { requestRun, dialog };
}

export default useCreditGate;
